const ns = '[Symbol Bar] ';

export const TOGGLE_EXPAND = `${ns}toggle panel expand`;
export const OPEN_EXPAND = `${ns}open panel expand`;
export const SELECT_SYMBOL = `${ns}select symbol`;
export const BAR_SIZE_CHANGED = `${ns}bar size changed`;
